<div class="relative inline-block" [style.width]="width">
  <button 
    type="button"
    (click)="toggleDropdown()" 
    [disabled]="disabled"
    class="w-full py-1.5 px-2 text-left bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 transition-all duration-200 flex items-center justify-between"
    [attr.aria-label]="'Dropdown: ' + getSelectedLabel()"
    [attr.aria-expanded]="isOpen">
    <span class="truncate">{{ getSelectedLabel() }}</span>
    <svg 
      class="w-5 h-5 ml-2 transition-transform duration-200"
      [class.rotate-180]="isOpen"
      fill="none" 
      stroke="currentColor" 
      viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
    </svg>
  </button>

    @if (isOpen) {
    <div 
      [class]="'absolute z-50 min-w-full bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden top-full mt-1 right-0'"
      [style.max-height]="maxHeight">
      
      <div class="overflow-y-auto" [style.max-height]="maxHeight">
        <ng-container *ngFor="let item of items">
          <button
            type="button"
            (click)="selectItem(item)"
            [disabled]="item.disabled || (!item.parentSelectable && item.subitems && item.subitems.length > 0)"
            [class.cursor-default]="!item.parentSelectable && item.subitems && item.subitems.length > 0"
            [class.font-semibold]="item.subitems && item.subitems.length > 0"
            [class.opacity-50]="item.disabled"
            class="w-full px-4 py-2 text-left hover:bg-gray-100 focus:bg-gray-100 focus:outline-none transition-colors duration-150 flex items-center gap-2"
            [attr.aria-label]="item.label">
            <fa-icon *ngIf="item.icon" [icon]="item.icon" class="text-gray-500"></fa-icon>
            <span>{{ item.label }}</span>
          </button>

          <ng-container *ngIf="item.subitems && item.subitems.length > 0">
            <button
              *ngFor="let subitem of item.subitems"
              type="button"
              (click)="selectItem(subitem)"
              [disabled]="subitem.disabled"
              [class.opacity-50]="subitem.disabled"
              [class.cursor-not-allowed]="subitem.disabled"
              class="w-full pl-12 pr-4 py-2 text-left text-sm hover:bg-gray-100 focus:bg-gray-100 focus:outline-none transition-colors duration-150 flex items-center gap-2"
              [attr.aria-label]="subitem.label">
              <fa-icon *ngIf="subitem.icon" [icon]="subitem.icon" class="text-gray-500"></fa-icon>
              <span>{{ subitem.label }}</span>
            </button>
          </ng-container>
        </ng-container>
        @if (items.length === 0) { 
          <div class="px-4 py-6 text-center text-gray-500">
            No items available
          </div>
        }
      </div>
    </div>
    }

</div>
